import { DashboardRoutes } from "@/router";
import { Close } from "@payping/icons";
import { Button, Card, Col, Drawer, Flex, Grid, Image, Page, Row, Typography } from "@payping/web-components";
import { useNavigate, useParams } from "react-router-dom";
import { SubLayout } from "@/components/SubLayout";
import { useAppTranslation } from "@/utils";
import { ServiceTypeEnum } from "@payping/api";
import { useState } from "react";
import { PluginItemType, featuredPluginsList, servicesAsPluginList, uiServiceAsPluginList } from "../data";
import Messaging from "./Messaging";
import DonateScript from "./DonateScript";
import NamadPayping from "./NamadPayping";
import { URLS } from "@payping/utilities-shared/consts";
import { PPFullColorLogoFa } from "@/core/utils";

const ConnectionsPluginsDetailsPage = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    navigate(DashboardRoutes.connections.plugins.root.url);
    setOpen(false);
  };
  const params = useParams();
  const { xs } = Grid.useBreakpoint();
  const { t } = useAppTranslation();

  const pluginName = params.name;
  if (!pluginName) {
    handleClose();
    return null;
  }

  const plugin = featuredPluginsList[String(pluginName) as keyof typeof featuredPluginsList];
  if (!plugin) {
    handleClose();
    return null;
  }

  return (
    <Drawer
      zIndex={10}
      onClose={() => {
        handleClose();
      }}
      width={"100%"}
      open={open}
      closeIcon={false}
      extra={
        <Button
          type={"text"}
          icon={<Close width={14} height={14} />}
          onClick={() => {
            handleClose();
          }}
        ></Button>
      }
      destroyOnClose
      title={
        <Flex align="center" gap="0.5rem">
          {xs ? null : <Image preview={false} src={PPFullColorLogoFa} width={60} height={24} />}
          <Typography.Text strong>{t("connections.plugins.details.title")}</Typography.Text>
        </Flex>
      }
    >
      <Page>
        <SubLayout>
          <Row>
            <Col lg={16}>
              <Flex vertical gap="1rem">
                <Typography.Title level={5}>
                  {t(`connections.plugins.featuredList.${plugin.translationKey}.title`)}
                </Typography.Title>
                <Typography.Paragraph>
                  {t(`connections.plugins.featuredList.${plugin.translationKey}.description`)}
                </Typography.Paragraph>
                <a href={plugin.helpLink || ""} target="_blank" rel="noreferrer">
                  <Button type="link">{t("userManual")}</Button>
                </a>
              </Flex>
            </Col>
            <Col lg={8}>
              <Image width={220} height={220} preview={false} src={plugin.logo} alt={plugin.translationKey} />
            </Col>
          </Row>
          <Row>
            <Col lg={16}>
              <Flex className="tw-mt-12">
                {Object.keys(servicesAsPluginList).includes(pluginName) ? (
                  <Messaging plugin={plugin as PluginItemType<ServiceTypeEnum>} />
                ) : null}
                {Object.keys(uiServiceAsPluginList).includes(pluginName) &&
                plugin.serviceType === uiServiceAsPluginList.donateScript.serviceType ? (
                  <DonateScript />
                ) : null}
                {Object.keys(uiServiceAsPluginList).includes(pluginName) &&
                plugin.serviceType === uiServiceAsPluginList.githubDonate.serviceType ? (
                  <Card.Ant>
                    <Image
                      src={`${URLS.STORAGE_URL}/payping-sponser.jpg`}
                      alt={plugin.translationKey}
                      width={"100%"}
                      height={"auto"}
                    />
                  </Card.Ant>
                ) : null}
                {Object.keys(uiServiceAsPluginList).includes(pluginName) &&
                plugin.serviceType === uiServiceAsPluginList.namadPayping.serviceType ? (
                  <NamadPayping />
                ) : null}
              </Flex>
            </Col>
          </Row>
        </SubLayout>
      </Page>
    </Drawer>
  );
};

export default ConnectionsPluginsDetailsPage;
